<template>
  <div>
    <app-button @click.native="onShowAddClientModal">Add clients</app-button>
    <app-cells>
      <h2 class="title">Clients details</h2>
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__full_name><div class="table-default__left">Full name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #h__status><div class="table-default__left">Status</div></template>
      <template #count="{ index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.client.citizenship ? row.client.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.client.citizenship ? row.client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.full_name }}
          </router-link>
          <span v-if="row.client.age">({{ row.client.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <router-link
            v-if="row.client.client.group"
            :to="{ name: 'clients-groups-general', params: { id: row.client.client.group.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.group.name }}
          </router-link>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #status="{ row }">
        <div class="table-default__left table-default__controls">
          <span class="status-tag" :style="{ 'backgroundColor': row.client.client.group.lead.status.color }">
            {{ row.client.client.group.lead.status.name }}
          </span>
        </div>
      </template>
      <template #medical="{ row }">
        <div class="table-default__controls">
            <span
              class="table-default__activity table-default__activity--medical-climbing table-default__activity--adds table-default__activity--active"
              :class="{
              'table-default__activity--medical-climbing-clock': !row.client.medical_clearance,
              'table-default__activity--medical-climbing-complete': row.client.medical_clearance,
              }"
            ></span>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowDeleteClientModal(row.id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="">
          </button>
        </div>
      </template>
    </v-client-table>
    <app-cells>
      <h2 class="title">Climbing group details</h2>
    </app-cells>
    <v-client-table
      :data="table_climbing.items"
      :columns="table_climbing.columns"
      :options="table_climbing.options"
      class="table-default"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Climbing group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.client.citizenship ? row.client.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.client.citizenship ? row.client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.full_name }}
          </router-link>
          <span v-if="row.client.age">({{ row.client.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__left">
          <router-link
            :to="{ name: 'climbing-groups-detail-clients', params: { id: row.client.group.id } }"
            class="table-default__link-border"
          >
            {{ row.client.group.name }}
          </router-link>
        </div>
      </template>
      <template #type="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.client.group.type.color }"
          >
            {{ row.client.group.type.name }}
          </span>
      </template>
      <template #route="{ row }">
        {{ row.client.group.route.name }}
      </template>
      <template #tour_start="{ row }">
        {{ dateFormat(row.client.group.tour_start) }}
      </template>
      <template #tour_end="{ row }">
        {{ dateFormat(row.client.group.tour_end) }}
      </template>
      <template #starting_point="{ row }">
        {{ row.client.group.starting_point?.short_name || '-' }}
      </template>
      <template #meeting_time="{ row }">
        {{ row.client.group.meeting_time || '-' }}
      </template>
    </v-client-table>
    <app-cells>
      <h2 class="title">Equipment checklist</h2>
    </app-cells>
    <v-client-table
      :data="table_equipment.items"
      :columns="table_equipment.columns"
      :options="table_equipment.options"
      class="table-default"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.client.citizenship ? row.client.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.client.citizenship ? row.client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.full_name }}
          </router-link>
          <span v-if="row.client.age">({{ row.client.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <router-link
            v-if="row.client.client.group"
            :to="{ name: 'clients-groups-general', params: { id: row.client.client.group.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.group.name }}
          </router-link>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #status="{ row }">
        <div class="table-default__controls">
          <a
            :href="`${family_url}${row.client.hash}/rentals/${row.client.group.id}`"
            target="_blank"
            class="table-default__activity table-default__activity--checklist table-default__activity--active table-default__activity--adds"
            :class="{
                'table-default__activity--checklist-total': row.client.checklist.completed && row.client.checklist.total_price === 0,
                'table-default__activity--checklist-time': !row.client.checklist.completed,
                'table-default__activity--checklist-complete': row.client.checklist.completed && row.client.checklist.total_price > 0
              }"
          ></a>
        </div>
      </template>
      <template #rental="{ row }">
        {{ row.client.checklist.rental_items }}
      </template>
      <template #purchase="{ row }">
        {{ row.client.checklist.purchase_items }}
      </template>
      <template #total="{ row }">
        {{ row.client.checklist.total_price ? row.client.checklist.total_price.toLocaleString() : 0 }} $
      </template>
    </v-client-table>
    <app-cells>
      <h2 class="title">Additional services</h2>
    </app-cells>
    <v-client-table
      :data="table_service.items"
      :columns="table_service.columns"
      :options="table_service.options"
      class="table-default"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.client.citizenship ? row.client.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.client.citizenship ? row.client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.full_name }}
          </router-link>
          <span v-if="row.client.age">({{ row.client.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <router-link
            v-if="row.client.client.group"
            :to="{ name: 'clients-groups-general', params: { id: row.client.client.group.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.group.name }}
          </router-link>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #additional_services.tent="{ row }">
        <template v-if="row.client.additional_services.tent">
          <span
            class="status-tag"
            :style="{ backgroundColor: row.client.additional_services.tent.service && row.client.additional_services.tent.service.code === 'private_tent' ? '#77b017' : row.client.additional_services.tent.service && row.client.additional_services.tent.service.code === 'walkin_tent' ? '#f0c427' : '#424242' }"
          >
            # {{ row.client.additional_services.tent.number }}
          </span>
        </template>
        <template v-else>-</template>
      </template>
      <template #additional_services.toilet="{ row }">
        <span v-if="row.client.additional_services.toilet" class="status-tag" :style="{ backgroundColor: '#424242' }">
          # {{ row.client.additional_services.toilet }}
        </span>
        <template v-else>-</template>
      </template>
      <template #additional_services.shower="{ row }">
        <span v-if="row.client.additional_services.shower" class="status-tag" :style="{ backgroundColor: '#424242' }">
          # {{ row.client.additional_services.shower }}
        </span>
        <template v-else>-</template>
      </template>
      <template #additional_services.phone="{ row }">
        <span v-if="row.client.additional_services.phone" class="status-tag" :style="{ backgroundColor: '#424242' }">
          # {{ row.client.additional_services.phone }}
        </span>
        <template v-else>-</template>
      </template>
      <template #additional_services.porter="{ row }">
        <span v-if="row.client.additional_services.porter" class="status-tag" :style="{ backgroundColor: '#424242' }">
          #{{ row.client.additional_services.porter }}
        </span>
        <template v-else>-</template>
      </template>
      <template #additional_services.water="{ row }">
        <span v-if="row.client.additional_services.water" class="status-tag" :style="{ backgroundColor: '#424242' }">
          Yes
        </span>
        <template v-else>-</template>
      </template>
    </v-client-table>
    <app-cells>
      <h2 class="title">Arrival details</h2>
    </app-cells>
    <v-client-table
      :data="table_arrival.items"
      :columns="table_arrival.columns"
      :options="table_arrival.options"
      class="table-default"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.client.citizenship ? row.client.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.client.citizenship ? row.client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.full_name }}
          </router-link>
          <span v-if="row.client.age">({{ row.client.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <router-link
            v-if="row.client.client.group"
            :to="{ name: 'clients-groups-general', params: { id: row.client.client.group.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.group.name }}
          </router-link>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #arrival_method="{ row }">
        <div class="table-default__controls">
          <span
            class="table-default__transport table-default__transport--arrival"
            :class="{
            'table-default__transport--present': row.client.client.transport.arrival.arrival_method,
            'table-default__transport--confirmed': row.client.client.transport.arrival.arrival_confirmed,
            'table-default__transport--car': row.client.client.transport.arrival.arrival_method?.code === 'car',
            'table-default__transport--bus': row.client.client.transport.arrival.arrival_method?.code === 'bus',
            'table-default__transport--self': row.client.client.transport.arrival.arrival_method?.code === 'self'
          }"
          ></span>
        </div>
      </template>
      <template #arrival_date="{ row }">
        {{ row.client.client.transport.arrival.arrival_date ? dateFormat(row.client.client.transport.arrival.arrival_date) : '-' }}
        {{ row.client.client.transport.arrival.arrival_time ? row.client.client.transport.arrival.arrival_time : '' }}
      </template>
      <template #arrival_location="{ row }">
        {{ row.client.client.transport.arrival.arrival_location ? row.client.client.transport.arrival.arrival_location.name : '-' }}
      </template>
      <template #arrival_notes="{ row }">
        <div class="table-default__controls">
          <div
            v-tooltip="{ content: row.client.client.transport.arrival.arrival_notes, placement: 'left', offset: 10 }"
            class="table-default__activity table-default__activity--notes"
            :class="{'table-default__activity--active': row.client.client.transport.arrival.arrival_notes}"
          ></div>
        </div>
      </template>
    </v-client-table>
    <app-cells>
      <h2 class="title">Departure details</h2>
    </app-cells>
    <v-client-table
      :data="table_departure.items"
      :columns="table_departure.columns"
      :options="table_departure.options"
      class="table-default"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.client.citizenship ? row.client.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.client.citizenship ? row.client.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.client.client.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.client.client.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.client.client.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.full_name }}
          </router-link>
          <span v-if="row.client.age">({{ row.client.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <router-link
            v-if="row.client.client.group"
            :to="{ name: 'clients-groups-general', params: { id: row.client.client.group.id } }"
            class="table-default__link-border"
          >
            {{ row.client.client.group.name }}
          </router-link>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #departure_method="{ row }">
        <div class="table-default__controls">
          <span
            class="table-default__transport table-default__transport--departure"
            :class="{
            'table-default__transport--present': row.client.client.transport.departure.departure_method,
            'table-default__transport--confirmed': row.client.client.transport.departure.departure_confirmed,
            'table-default__transport--car': row.client.client.transport.departure.departure_method?.code === 'car',
            'table-default__transport--bus': row.client.client.transport.departure.departure_method?.code === 'bus',
            'table-default__transport--self': row.client.client.transport.departure.departure_method?.code === 'self'
          }"
          ></span>
        </div>
      </template>
      <template #departure_date="{ row }">
        {{ row.client.client.transport.departure.departure_date ? dateFormat(row.client.client.transport.departure.departure_date) : '-' }}
        {{ row.client.client.transport.departure.departure_time ? row.client.client.transport.departure.departure_time : '' }}
      </template>
      <template #departure_location="{ row }">
        {{ row.client.client.transport.departure.departure_location ? row.client.client.transport.departure.departure_location.name : '-' }}
      </template>
      <template #departure_notes="{ row }">
        <div class="table-default__controls">
          <div
            v-tooltip="{ content: row.client.client.transport.departure.departure_notes, placement: 'left', offset: 10 }"
            class="table-default__activity table-default__activity--notes"
            :class="{'table-default__activity--active': row.client.client.transport.departure.departure_notes}"
          ></div>
        </div>
      </template>
    </v-client-table>
    <modal
      name="delete-client-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideDeleteClientModal" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete client
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this client?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onHideDeleteClientModal" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteClient" ref="deleteClient">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="add-client-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('add-client-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Add clients</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckAddForm">
            <app-form-group label="Client" required>
              <app-select
                @input="onCheckClient"
                @search="onClientsSearch"
                v-model="add_client_form.client"
                :options="clients_options"
                :filterable="false"
                :clearable="false"
                label="full_name"
                placeholder="Client"
                :error="$v.add_client_form.client.$error"
              />
              <template #error>
                <div v-if="$v.add_client_form.client.$dirty && !$v.add_client_form.client.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Group" required>
              <app-select
                v-model="add_client_form.climbing_group"
                :reduce="item => item.id"
                :options="groups_options"
                :filterable="false"
                :clearable="false"
                :searchable="false"
                :readonly="!add_client_form.client"
                placeholder="Group"
                :error="$v.add_client_form.climbing_group.$error"
              />
              <template #error>
                <div v-if="$v.add_client_form.climbing_group.$dirty && !$v.add_client_form.climbing_group.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="addClient" type="submit">Add</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteClimbingBriefingClient,
  getClientsLite,
  getClimbingBriefingClients,
  getClimbingGroupsSearch,
  postClimbingBriefingClients,
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

export default {
  name: 'ClimbingEventsDetailClients',
  data() {
    return {
      family_url: process.env.VUE_APP_FAMILY,
      table: {
        items: [],
        columns: ['count', 'full_name', 'group', 'status', 'medical', 'controls'],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'group': 'Group',
            'status': 'Status',
            'medical': 'Medical',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_climbing: {
        items: [],
        columns: ['count', 'full_name', 'group', 'type', 'route', 'tour_start', 'tour_end', 'starting_point', 'meeting_time'],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'group': 'Group',
            'type': 'Type',
            'route': 'Route',
            'tour_start': 'Start',
            'tour_end': 'Finish',
            'starting_point': 'Starting point',
            'meeting_time': 'Meeting time',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_equipment: {
        items: [],
        columns: ['count', 'full_name', 'group', 'status', 'rental', 'purchase', 'total'],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'group': 'Group',
            'status': 'Status',
            'rental': 'Rental',
            'purchase': 'Purchase',
            'total': 'Total',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_service: {
        items: [],
        columns: [
          'count',
          'full_name',
          'group',
          'additional_services.tent',
          'additional_services.toilet',
          'additional_services.shower',
          'additional_services.phone',
          'additional_services.porter',
          'additional_services.water'
        ],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'group': 'Group',
            'additional_services.tent': 'Tent',
            'additional_services.toilet': 'Toilet',
            'additional_services.shower': 'Shower',
            'additional_services.phone': 'Phone',
            'additional_services.porter': 'Porter',
            'additional_services.water': 'Water'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_arrival: {
        items: [],
        columns: ['count', 'full_name', 'group', 'arrival_method', 'arrival_date', 'arrival_location', 'arrival_notes'],
        options: {
          headings: {
            count: '#',
            full_name: 'Full name',
            group: 'Group',
            arrival_method: 'Transport',
            arrival_date: 'Date',
            arrival_location: 'Location',
            arrival_notes: 'Notes',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_departure: {
        items: [],
        columns: ['count', 'full_name', 'group', 'departure_method', 'departure_date', 'departure_location', 'departure_notes'],
        options: {
          headings: {
            count: '#',
            full_name: 'Full name',
            group: 'Group',
            departure_method: 'Transport',
            departure_date: 'Date',
            departure_location: 'Location',
            departure_notes: 'Notes',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      client_to_delete: null,
      add_client_form: {
        climbing_group: '',
      },
      groups_options: [],
      clients_options: [],
    }
  },
  validations: {
    add_client_form: {
      client: { required },
      climbing_group: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    this.getBriefingClients()

  },
  methods: {
    getBriefingClients() {
      getClimbingBriefingClients(this.$route.params.id)
        .then(response => {
          this.table.items = response.data
          this.table_climbing.items = response.data
          this.table_equipment.items = response.data
          this.table_service.items = response.data
          this.table_arrival.items = response.data
          this.table_departure.items = response.data
        })
    },
    onShowDeleteClientModal(id) {
      this.client_to_delete = id
      this.$modal.show('delete-client-modal')
    },
    onHideDeleteClientModal() {
      this.$modal.hide('delete-client-modal')
    },
    onCheckClient() {
      getClimbingGroupsSearch({ client: this.add_client_form.client.id })
        .then(res => {
          this.groups_options = res.data
          if (this.groups_options.length) this.add_client_form.climbing_group = this.groups_options[0].id
        })
    },
    onDeleteClient() {
      this.$refs.deleteClient.preload = true
      deleteClimbingBriefingClient(this.$route.params.id, this.client_to_delete)
        .then(() => {
          this.getBriefingClients()
          this.$emit('update-info')
          this.$notify({
            type: 'success',
            title: 'Client deleted',
          })
          this.onHideDeleteClientModal()
        })
        .catch(() => {
          this.$refs.deleteClient.preload = false
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    tooltipContent(data) {
      return `${data.updated_by.full_name}<br>${this.dateTimeFormat(data.updated_at)}`
    },
    clientTableList(clients) {
      let result = ''
      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    onShowAddClientModal() {
      this.$modal.show('add-client-modal')
    },
    onCheckAddForm() {
      this.$v.add_client_form.$touch()
      if (this.$v.add_client_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendAddClientForm()
      }
    },
    sendAddClientForm() {
      this.$refs.addClient.preload = true
      postClimbingBriefingClients(this.$route.params.id, [{climbing_group: this.add_client_form.climbing_group, client: this.add_client_form.client.id}])
        .then(() => {
          this.getBriefingClients()
          this.$emit('update-info')
          this.$notify({
            type: 'success',
            title: 'Client added',
          })
          this.$modal.hide('add-client-modal')
          this.add_client_form = {
            climbing_group: ''
          }
          this.$v.add_client_form.$reset()
        })
        .catch(() => {
          this.$refs.addClient.preload = false
        })
    },
    onClientsSearch(search, loading) {
      loading(true)
      this.searchClient(loading, search, this)
    },
    searchClient: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.clients_options = []
      } else {
        getClientsLite({search}).then(response => {
          vm.clients_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>
